module.exports = __webpack_public_path__ + "img/goodness-24.e5fbd2d2.png";